class PurchaseOrderService extends BaseService
	@register angular.module 'App.Service'
	@inject '$filter',
		'PurchaseOrderRepository'
		'PURCHASE_ORDER'
		'CopyService'
		'PurchaseOrderShippingCostService'

	initialize: ->
		@fields =
			order: [
				'id'
				'name'
				'revision_number'
				'status'
				'email'
				'stock_location_id'
				'supplier_id'
				'shop_id'
				'expected_delivery_time'
				'delivery_time'
				'delivery_type'
				'external_id'
				'external_status'
				'invoice_time'
				'invoice_reference'
				'shipping_cost'
				'comment'
			]
			lineItem: [
				'id'
				'cost_price'
				'purchase_order_id'
				'product_id'
				'product_variant_id'
				'requested_quantity'
				'received_quantity'
				'unit_id'
				'number_in_package'
				'deleted'
			]

	save: (purchaseOrder, modifiedItemsOnly = false) ->
		order = @filterData purchaseOrder, @fields.order, modifiedItemsOnly

		return @PurchaseOrderRepository.save order, undefined, true

	filterData: (purchaseOrder, fields, modifiedItemsOnly = false) ->
		data = {}

		for attribute, value of purchaseOrder
			if fields.includes attribute
				data[attribute] = value

			if attribute == 'line_items'
				data.line_items = []

				for lineItem in value
					if modifiedItemsOnly && lineItem.dirty != true && lineItem.deleted != true
						continue

					lineItemData = @filterData(lineItem, @fields.lineItem)
					lineItemData.received_quantity ?= lineItemData.requested_quantity

					data.line_items.push(lineItemData)

				if _.isEmpty(data.line_items)
					delete data.line_items

		return data

	getDeliveryTypes: ->
		return [
			{
				id: @PURCHASE_ORDER.DELIVERY_TYPE.SHOP
				name: @$filter('translate')('general.shop')
			}
			{
				id: @PURCHASE_ORDER.DELIVERY_TYPE.STOCK_LOCATION
				name: @$filter('translate')('general.stock.location')
			}
		]

	getEntityCopy: (originalId) ->
		query = @PurchaseOrderRepository.createQuery()
		query.with 'line_items'

		defaultEntity =
			is_new: true
			line_items: []

		return @PurchaseOrderRepository
			.getEntity(originalId, query, defaultEntity)
			.then (data) =>
				entity = @CopyService.copyEntity(data, {line_items: ['purchase_order_id', 'received_quantity']})
				entity.revision_number = '1'
				entity.status = @PURCHASE_ORDER.STATUS.ACTIVE

				return entity
